export default __webpack_public_path__ + "static/media/salesForce_logo.a95fdb22.png";